<template>
    <hts-tooltip reference-class="flex">
        <p>
            {{ data }}
        </p>
        <template #reference>
            <span class="leading-[41px]">
                {{ data }}
            </span>
        </template>
    </hts-tooltip>
</template>
<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref()

onBeforeMount(() => {
  data.value = params?.value?.data.name || ''
})
</script>
